import { CODE_FOLD_DEL, CODE_FOLD_DET, CODE_FOLD_LIST, CODE_FOLD_SAVE } from "../actions/action-types";
import { initialStateDatasArray, initialSTateDatasData, initialStateNext } from "../helpers";

// Liste des dossiers
export function ListFolderReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case CODE_FOLD_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Détail d'un dossier
export function DetailFolderReducer(state = initialSTateDatasData, action) {
    switch (action.type) {
        case CODE_FOLD_DET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Sauvegarde d'un dossier
export function SaveFolderReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CODE_FOLD_SAVE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Suppression d'un dossier
export function DeleteFolderReducer(state = initialStateNext, action) {
    switch (action.type) {
        case CODE_FOLD_DEL:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}
